import React from "react";

import cx from "classnames";

import { IconButton } from "../IconButton";
import { Loader } from "../Loader";
import { Text } from "../Text";

import styles from "./HighFive.scss";

export interface HighFiveProps {
  /** HighFive icon state based on point validation */
  enabled?: boolean | null;
  /** Indicates if component is in loading state */
  loading?: boolean;
  /** Indicates selected state */
  selected?: boolean;
  /** Indicates if HighFive needs to show label */
  includeLabel?: boolean;
  /** Label Text for Recognition view */
  label?: string;
  /** Changes icon size, default is 16 */
  iconSize?: 8 | 12 | 16 | 24;
  /** Function called when HighFive is clicked */
  onSelected?: (selected: boolean) => void;
  /** Function called when HighFive is given */
  giveHighFive?: () => void;
  /** Passes the number of high fives to IconButton */
  quantity?: number;
  /** Additional CSS class name */
  className?: string;
}

/**
 * A HighFive component with built in confirmation modal.
 *
 * Notes:
 * - HighFive component designed to be included in Recognition or BehaviorBonus components
 * - HighFive will provide confirmation modal after clicking an icon
 */
export function HighFive({
  enabled = true,
  loading = false,
  selected,
  includeLabel,
  label,
  iconSize = 16,
  onSelected,
  quantity,
  className,
}: HighFiveProps) {
  const containerClass = cx(styles.container, className);

  if (loading) {
    return (
      <div className={styles["loader-container"]}>
        <Loader size="small" />
      </div>
    );
  }

  return (
    <>
      <IconButton
        variant="transparent"
        className={containerClass}
        ariaLabel={label}
        onClick={() => onSelected?.(!selected)}
        disabled={!enabled}
        iconSize={iconSize}
        system={!selected && Boolean(enabled)}
        icon="high_five"
        quantity={quantity}
      >
        {Boolean(includeLabel) && <Text size="small">{label}</Text>}
      </IconButton>
    </>
  );
}
